<template>
	<vs-dialog v-model="active" width="800px" @close="borrarInfo" prevent-close>
      <template #header>
      <h4 class="not-margin">
          Crear acceso
      </h4>
      </template>
      <div class="con-form">
        <vs-row>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="nombre" class="labelInput">
                        Nombre <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-input v-model="nombre" placeholder="Nombre">
                        <template #message-danger v-if="errorFields.includes('nombre')">
                            Requerido
                        </template>
                    </vs-input>
                </form>
            </vs-col>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="nombre" class="labelInput">
                        Correo electrónico <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-input type="mail" v-model="mail" placeholder="Correo electrónico">
                        <template #message-danger v-if="errorFields.includes('mail')">
                           Requerido 
                        </template>
                    </vs-input>
                </form>
            </vs-col>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="nombre" class="labelInput">
                        Contraseña <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-input v-model="password" placeholder="Contraseña">
                        <template #message-danger>
                           <span v-if="errorFields.includes('password')">Requerido</span>  
                           <span v-if="equalPassword">Las contraseñas no son identicas</span> 
                        </template>
                    </vs-input>
                </form>
            </vs-col>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="nombre" class="labelInput">
                        Confirmar contraseña <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-input @blur="confirmarPassword()" v-model="password2" placeholder="Confirmar contraseña">
                        <template #message-danger>
                           <span v-if="equalPassword">Las contraseñas no son identicas</span>
                        </template>
                    </vs-input>
                </form>
            </vs-col>
            <vs-col sm="12" lg="6">
                <div class="d-flex " style="justify-content: space-between;">
                    <label for="institucion" class="labelInput">
                        Institución <i class="fas fa-shield-alt"></i>
                    </label>
                    <div class="d-flex" v-if="instituciones[0]">
                        <div>
                            <vs-tooltip>
                                <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(instituciones, 'institucion')"></i>
                                <template #tooltip>
                                    Seleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        <div class="labelInput">
                            <vs-tooltip>
                                <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('institucion')"></i>
                                <template #tooltip>
                                    Deseleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                    </div>
                </div>
                <vs-select filter multiple collapse-chips class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                    <template #message-danger v-if="errorFields.includes('institucion')">
                        Requerido
                    </template>
                    <template v-if="instituciones.length" autocomplete="off">
                        <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </template>
                    <template v-else>
                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                        </vs-option>
                    </template>
                </vs-select>
            </vs-col>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Rol <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingRol" class="aqui pt-0" id="institucion" placeholder="Seleccionar el rol" :key="rolId" v-model="rol" :disabled="!roles[0]">
                        <template #message-danger v-if="errorFields.includes('rol')">
                            Requerido
                        </template>
                        <template>
                            <vs-option v-for="option in roles" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
        </vs-row>
      </div>

      <template #footer>
      <div class="footer-dialog">
            <vs-row>
                <vs-col sm="6" lg="6">
                <vs-button
                    danger
                    flat
                    @click="borrarInfo()">
                    Cancelar
                </vs-button>
                </vs-col>
                <vs-col sm="6" lg="6">
                <vs-button
                    :disabled="password != password2"
                    success
                    class="ml-auto"
                    @click="postCrearAcceso()">
                    Guardar
                </vs-button>
                </vs-col>
            </vs-row>
      </div>
      </template>
  </vs-dialog>
</template>

<script>
import accesibilidad from '../../../../../api/requests/accesibilidad'
export default {
	props:[
	  'value',
      'instituciones',
      'institucionId'
  ],
    data () {
        return {
        active: false,
        nombre: '',
        nombre_usuario: '',
        mail:'',
        password: '',
        password2: '',
        institucion: [],
        rol: [],
        roles: [],
        rolId: (new Date()).getTime(),
        loadingRol: false,
        errorFields:[],
        equalPassword: false
        }
    },
    methods: {
        selectAll(seleccion, tipo){
              let arr = []
            seleccion.forEach(i => {
              arr.push(i.id)
            })
            if(tipo == 'institucion'){
                this.institucion = arr
            }
            if(tipo == 'rol'){
                this.rol = arr
            }
        },
        deseleccionarAll(tipo){
            if(tipo == 'institucion'){
                this.institucion = []
            }
            if(tipo == 'rol'){
                this.rol = []
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.rol) {
                this.errorFields.push('rol')
            }
            if (!this.errorFields.length){
                
                return true
            } else {
                return null
            }
        }, 
        async getRol(){
            try {
                this.loadingRol = true
                let params = {
                    'instituciones': this.institucion
                }
                const response = await accesibilidad.getMultiRoles(params)
                this.roles = response.data
                this.rolId = (new Date()).getTime()
                this.loadingRol = false
            }
            catch{

            }
        },
        confirmarPassword(){
            if(this.password != this.password2){
                this.equalPassword = true
            }else{
                this.equalPassword = false
            }
        },
        async postCrearAcceso(){
            if(this.sanityForm()){
                const loading = this.$vs.loading()
                try{
                    const datos = {
                        name: this.nombre,
                        username: this.mail,
                        email: this.mail,
                        password: this.password,
                        roles: this.rol
                    }
                    if(this.institucion[0] == ''){
                        const eliminarGrupo = this.institucion.shift()
                        datos.instituciones = this.institucion
                    }else{
                        datos.instituciones = this.institucion
                    }
                    const { data: response } = await accesibilidad.postCrearAcceso(datos)
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: 'Se ha creado el rol con éxito'
                    })
                    this.$emit('refreshTable', this.institucion, this.rol)
                    this.borrarInfo()
                }catch(error){
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        duration: 10000,
                        title: 'Se produjo un error',
                        text: error.response.data.message
                    })
                }
            }
        },
        borrarInfo(){
            this.active = false
            this.nombre = ''
            this.mail = ''
            this.username = ''
            this.password = ''
            this.password2 = ''
            this.institucion = []
            this.rol = []
        }
    },
    watch: {
        value (val) {
        this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        institucion(){
            this.getRol()
        }
    }
}
</script>
